export default "__VITE_ASSET__Ctsi5bwf__"